<template>
  <div class="main repwdMain">
    <!-- 上部分 -->
    <div class="title" style="margin-bottom: 80px;">
      <span class="text">
        修改密码
        <span>
          (
          <span style="color: #FF0000">*</span>为必填项)
        </span>
      </span>
    </div>

    <!-- 下部分 -->
    <el-form
      :label-position="labelPosition"
      label-width="400px"
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
    >
      <el-form-item label="请输入旧密码" prop="password" required>
        <el-input v-model="ruleForm.password" clearable show-password></el-input>
      </el-form-item>
      <el-form-item label="请输入新密码" prop="newPassword" required>
        <el-input v-model="ruleForm.newPassword" clearable show-password></el-input>
      </el-form-item>
      <el-form-item label="请再次输入新密码" prop="newPassword1" required>
        <el-input v-model="ruleForm.newPassword1" clearable show-password></el-input>
      </el-form-item>
    </el-form>
    <div class="btn">
      <el-button type="primary" @click="submitForm">确认</el-button>
    </div>
  </div>
</template>

<script>
import * as Cache from '../utils/cache'
import * as API from '../utils/apiService'

export default {
  data () {
    var validatePassword = (rule, value, callback) => {
      if (!value) {
        callback(new Error('旧密码不能为空！'))
      } else if (
        this.ruleForm.newPassword &&
        value === this.ruleForm.newPassword
      ) {
        callback(new Error('旧密码与新密码一致！'))
      } else {
        callback()
      }
    }
    var validateNewPassword = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入新密码！'))
      } else if (this.ruleForm.password) {
        this.$refs.ruleForm.validateField('password')
        callback()
      } else {
        if (this.ruleForm.newPassword1) {
          this.$refs.ruleForm.validateField('newPassword1')
        }
        callback()
      }
    }
    var validateNewPassword1 = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请再次输入新密码！'))
      } else if (value !== this.ruleForm.newPassword) {
        callback(new Error('新密码与确认密码不一致!'))
      } else {
        callback()
      }
    }

    return {
      labelPosition: 'right',
      ruleForm: {
        password: '',
        newPassword: '',
        newPassword1: ''
      },
      rules: {
        password: [{ validator: validatePassword, trigger: 'blur' }],
        newPassword: [{ validator: validateNewPassword, trigger: 'blur' }],
        newPassword1: [{ validator: validateNewPassword1, trigger: 'blur' }]
      }
    }
  },
  methods: {
    submitForm () {
      this.$refs.ruleForm.validate(valid => {
        if (!valid) {
          this.$message.error('请重新填写密码!')
          return
        } else {
          let params = {
            username: Cache.getUserInfo().username,
            password: this.ruleForm.password,
            newPassword: this.ruleForm.newPassword
          }
          API.resetPwd(params).then(resp => {
            if (resp.resultCode === '0000') {
              this.$message.success('修改成功')
              this.$router.push('/login')
            } else {
              this.$message.error(resp.resultMsg)
            }
          })
        }
      })
    }
  }
}
</script>

<style lang="scss">
.repwdMain {
  .subBtn {
    .el-form-item__content {
      text-align: center !important;
      margin-left: -35px !important;
    }
  }
  .btn {
    margin-top: 70px;
    margin-left: 400px;
  }
}
</style>
